<template>
    <div v-if="userInfo.id" class="container">

        <div class="item-headder">
            <v-gravatar class="image" draggable="false" :size="500" :email="userInfo.email" />
            <div>
                <h2>{{userInfo.name}}</h2>
                <p>{{userInfo.email}} - {{userInfo.id}}</p>
            </div>
        </div>
        <div class="action-panel">
            <router-link tag="div" :to="'/cases/create/'+$route.params.uniqueid" class="btn">Create case</router-link>
            <router-link tag="div" :to="'/invoices/create/'+$route.params.uniqueid" class="btn">Create invoice</router-link>
        </div>
        <div class="warpper">
            <input class="radio" id="one" name="group" type="radio" checked>
            <input class="radio" id="two" name="group" type="radio">
            <input class="radio" id="three" name="group" type="radio">
            <input class="radio" id="four" name="group" type="radio">
            <div class="tabs">
                <label class="tab" id="one-tab" for="one">Account</label>
                <label class="tab" id="two-tab" for="two">Products ({{(products_table.data.length || 1)-1}})</label>
                <label class="tab" id="three-tab" for="three">Invoices ({{(invoices_table.data.length || 1)-1}})</label>
                <label class="tab" id="four-tab" for="four">Cases ({{(cases_table.data.length || 1)-1}})</label>
            </div>
            <div class="panels">
                <div class="panel" id="one-panel">
                    <h2>User information</h2>
                    <div class="div-table row">
                        <div>
                            <p>ID</P>
                            <span>
                                {{userInfo.id}}
                            </span>
                        </div>
                        <div>
                            <p>Account type</P>
                            <span>
                                <div class="btn sm" :class="{'selected main' : (userInfo.type == 'individual')}" v-on:click="userInfo.type = 'individual'">
                                    Individual
                                </div>
                                <div class="btn sm" :class="{'selected main' : (userInfo.type == 'buisness')}" v-on:click="userInfo.type = 'buisness'">
                                    Buisness
                                </div>
                            </span>
                        </div>
                        <div v-if="userInfo.type != 'individual'">
                            <p>Company nr.</P>
                            <span>
                                <input type="text" maxlength="255" v-model="userInfo.company_no"/>
                            </span>
                        </div>
                        <div>
                            <p>Name</P>
                            <span>
                                <input type="text" maxlength="255" v-model="userInfo.name"/>
                            </span>
                        </div>
                        <div>
                            <p>Adress</P>
                            <span>
                                <input type="text" maxlength="255" v-model="userInfo.address"/>
                            </span>
                        </div>
                        <div>
                            <p>Country</P>
                            <span>
                                <country-flag :country='userInfo.country' size='small'/>
                                <country-select v-model="userInfo.country" :country="userInfo.country" topCountry="DK" />
                            </span>
                        </div>
                        <div>
                            <p>Language</P>
                            <span>
                                {{userInfo.lang}}
                            </span>
                        </div>
                        <div>
                            <p>Suspended</P>
                            <span >
                                <div class="btn sm" :class="{'selected red' : (userInfo.suspended == 1)}" v-on:click="userInfo.suspended = 1">
                                    Suspend<span v-if="userInfo.suspended == 1">ed</span>
                                </div>
                                <div class="btn sm" :class="{'selected main' : (userInfo.suspended == 0)}" v-on:click="userInfo.suspended = 0">
                                    Unsuspend<span v-if="userInfo.suspended == 0">ed</span>
                                </div>
                            </span>
                        </div>
                        <div>
                            <p>Created</P>
                            <span>
                                {{dateTimeFormat(userInfo.creation_date)}}
                            </span>
                        </div>
                    </div>
                    <h2>Contactinformation</h2>
                    <div class="div-table row">
                        <div>
                            <p>Email</P>
                            <span>
                                <input type="text" maxlength="255" v-model="userInfo.email"/>
                                <div v-if="userInfo.email_verified == 1" class="btn sm green" v-on:click="userInfo.email_verified = 0">Verified</div>
                                <div v-else class="btn sm red" v-on:click="userInfo.email_verified = 1">Unverified</div>
                            </span>
                        </div>
                        <div>
                            <p>Phone</P>
                            <span>
                                <input type="text" maxlength="255" v-model="userInfo.phone"/>
                                <div v-if="userInfo.phone_verified == 1" class="btn sm green" v-on:click="userInfo.phone_verified = 0">Verified</div>
                                <div v-else class="btn sm red" v-on:click="userInfo.phone_verified = 1">Unverified</div>
                            </span>
                        </div>
                    </div>

                    <div class="action-panel">
                        <div class="btn" v-on:click="saveCustomerData()">Save changes</div>
                    </div>
                </div>
                <div class="panel" id="two-panel">
                    <vue-table-dynamic @row-click="clickProductTable" class="tableModifier" :params="products_table" ref="products_table"></vue-table-dynamic>
                </div>
                <div class="panel" id="three-panel">
                    <vue-table-dynamic @row-click="clickInvoiceTable" class="tableModifier" :params="invoices_table" ref="invoices_table"></vue-table-dynamic>
                </div>
                <div class="panel" id="four-panel">
                    <vue-table-dynamic @row-click="clickCaseTable" class="tableModifier" :params="cases_table" ref="cases_table"></vue-table-dynamic>
                </div>
            </div>
        </div>
    </div>
    <Loading v-else/>
</template>
<style scoped lang="scss">
    
</style>
<script>
import VueTableDynamic from 'vue-table-dynamic'
import CountryFlag from 'vue-country-flag'
import Loading from '@/components/parts/Loading.vue'
import {CountrySelect} from 'vue-country-region-select'

export default {
    name: 'Customer',
    components: { VueTableDynamic, CountryFlag, "country-select": CountrySelect, Loading },
    computed: {
        modifyUser: function(){
            return JSON.stringify(this.userInfo) === JSON.stringify(this.userInfoBackup);
        }
    },
    data() {
        return {
            country: '',
            userInfo: {
                country: 'DK',
            },
            userInfoBackup: {
                country: 'DK',
            },
            invoices: [],
            cases: [],
            products: [],

            invoices_table: {
                data: [],
                header: 'row',
                enableSearch: true,
                pagination: true,
                pageSize: 15,
                pageSizes: [],
                sort: [0,1],
                maxWidth:2000,
                tablehead: [['Invoice ID','Creation Date','Note','Status']],
            },
            cases_table: {
                data: [],
                header: 'row',
                enableSearch: true,
                pagination: true,
                pageSize: 15,
                pageSizes: [],
                sort: [0,2,3,4,5],
                maxWidth:2000,
                tablehead: [['Case ID','Subject','Department','Status','Created at','Last Update at']],
            },
            products_table: {
                data: [],
                header: 'row',
                enableSearch: true,
                pagination: true,
                pageSize: 15,
                pageSizes: [],
                sort: [2,3,4,5,6],
                maxWidth:2000,
                tablehead: [['Support ID','Description','Status','Creation Date','Expires at','Product Category','Autorenew']],
            },
        


        }
    },
    methods: {
        clickProductTable(index, data) {
            if(data[0]!='Support ID'){
                this.$router.push('/products/'+data[0]);
            }
        },
        clickInvoiceTable(index, data){
            if(data[0]!='Invoice ID'){
                this.$router.push('/invoices/'+data[0]);
            }
        },
        clickCaseTable(index, data){
            if(data[0]!='Case ID'){
                this.$router.push('/cases/'+data[0]);
            }
        },
        savedResponse(error, response){
            //OK = 200
            //Error = 204
            console.log("save data- "+error);
            console.log(response);
            if(error == 200){
                document.getElementById("Toast1").classList.remove("red");
                document.getElementById("Toast1").classList.remove("hide");
                document.getElementById("Toast1").classList.add("green");
                document.getElementById("Toast1").innerText = "The changes was saved";
                setTimeout(function() {
                    document.getElementById("Toast1").classList.add("hide");
                }, 3000);
            }else{
                document.getElementById("Toast1").classList.remove("green");
                document.getElementById("Toast1").classList.remove("hide");
                document.getElementById("Toast1").classList.add("red");
                document.getElementById("Toast1").innerText = "Could not save changes. Errorcode " + error;
                setTimeout(function() {
                    document.getElementById("Toast1").classList.add("hide");
                }, 3000);
            }
        },
        saveCustomerData(){
            var vue = this;
            this.$socket.client.emit('setUserInfo',vue.userInfo, (error, response) => {
                vue.savedResponse(error, response);
            })
        },
        getCustomerData(){
            var vue = this;
            this.$socket.client.emit('getUserInfo',vue.$route.params.uniqueid, (error, response) => {
                if(error=='200'){
                    response.country = response.country.toUpperCase();
                    vue.userInfo = response;
                    vue.userInfoBackup = Object.assign({}, response);
                }
            })
            this.$socket.client.emit('getUserInvoices',vue.$route.params.uniqueid, (error, response) => {
                if(error=='200'){
                    vue.invoices_table.data = vue.invoices_table.tablehead.concat(response.map(data => [data.id,data.creation_day,data.note,data.payment_day]));
                    vue.invoices = response;
                }
            })
            this.$socket.client.emit('getUserCases',vue.$route.params.uniqueid, (error, response) => {
                if(error=='200'){
                    vue.cases_table.data = vue.cases_table.tablehead.concat(response.map(data => [data.caseid,atob(data.subject),data.title,data.status,data.creation,data.updated]));
                    vue.cases = response;
                }
            })
            this.$socket.client.emit('getUserProducts',vue.$route.params.uniqueid, (error, response) => {
                if(error=='200'){
                    vue.products_table.data = vue.products_table.tablehead.concat(response.map(data => [data.supportid,data.description,data.status,data.creation,data.deletion,data.productid,data.autorenew]));
                    vue.products = response;
                }
            })
        },
        dateTimeFormat : function(input){
            var date = new Date(input);
            return date.getDate() + ". " + this.$store.state.monthsShort[date.getMonth()] + " " + date.getFullYear() + " - " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
        }
    },
    mounted() {
        this.getCustomerData();
    },
}
</script>